import React from "react";
import "../styles/Description.css";

export default function Description() {
  return (
    <div className="description">
      <h2 className="descriptionTitle">Description</h2>
      <h3 className="descriptionText">
        The Daydream Player concept revives the charm and nostalgia of
        early-2000s tech in a modern streaming based tactile music player.
      </h3>
    </div>
  );
}
